import type { SelectorOptionPropsInterface } from 'sonata-react-components';
import type { GroupView } from '../domain/grouping.types';

/** Selector options for a list of groups (value = group id). */
export function toGroupOptions(groups: GroupView[]): SelectorOptionPropsInterface[] {
  return groups.map(group => ({ id: group.id, label: group.name, value: group.id }));
}

const isOption = (value: unknown): value is SelectorOptionPropsInterface =>
  typeof value === 'object' && value !== null && 'value' in value;

const toOptions = (selected: unknown): SelectorOptionPropsInterface[] =>
  (Array.isArray(selected) ? selected : [selected]).filter(isOption);

/** Picked value from the (untyped) Selector `onChange` payload: a single option or an array of them. */
export function firstOptionValue(selected: unknown): string | null {
  const [first] = toOptions(selected);
  return first ? String(first.value) : null;
}

/** Every picked value from the (untyped) Selector `onChange` payload. */
export function optionValues(selected: unknown): string[] {
  return toOptions(selected).map(option => String(option.value));
}
